interface StatusBadgeProps {
  status: "connected" | "untested" | "error";
}

export function StatusBadge({ status }: StatusBadgeProps) {
  const badgeConfig = {
    connected: {
      label: "Connected",
      className:
        "bg-green-100 text-green-700 dark:bg-green-950/30 dark:text-green-400",
    },
    untested: {
      label: "Untested",
      className: "bg-gray-200 text-gray-700 dark:bg-gray-700 dark:text-gray-300",
    },
    error: {
      label: "Error",
      className: "bg-red-100 text-red-700 dark:bg-red-950/30 dark:text-red-400",
    },
  };

  const config = badgeConfig[status];

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold leading-tight ${config.className}`}
      data-testid={`status-badge-${status}`}
    >
      {config.label}
    </span>
  );
}